import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payouts")({
  component: lazyRouteComponent(() => import("./-pages/admin.payouts")),
  head: () => ({
    meta: [
      { title: "Admin · Payouts — Lecmo" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
